<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { customerService } from "../../../services/contactservice/customer.service";
import { customertypeService } from "../../../services/contactservice/customertype.service";
import { servicehelpers } from "../../../services/servicehelpers";
import List from "../../../components/list";
import Screen from "../../../components/screen";
import i18n from "../../../i18n";

/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Customers List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      ...Screen.Alert,
      ...Screen.Locate,
      customerData: {},
      typeData: {},
      statusData: {},
      fetchingStats: false,
      title: "Customers List",

    };
  },
  mounted() {
    /* eslint-disable no-console */
      // fetch("https://vuetable.ratiw.net/api/users", {method: 'get'})
      //   .then(response => response.json())
      //   .then(data => console.log(data));

    this.loadingCustomerTypeData();
    this.loadingData();
    this.loadingpropertyStatusData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      customerService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.customerData = response;

          // console.warn(JSON.stringify(this.customerData));
        });
    },

    loadingCustomerTypeData: function() {
      customertypeService.getList()
        .then(response => {
          this.typeData = response;

        });
    },

    loadingpropertyStatusData: function() {
      servicehelpers.getCustomerStatusData().then(response => {
        this.statusData = response;
      });
    },

    deleted: function(id) {
      customerService.remove(id)
        .then(response => {
        
          // this.customerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "customer-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'customer-add'}" :title="$t('menuitems.customer.text')" />
    <List v-bind:dataList="customerData" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[{name: 'status', color: true}]"
          v-bind:fields="[ `code: ${$t('customer.code')}`, `name: ${$t('customer.name')}`, `type: ${$t('customer.type')}`, 
            `phone_no_1: ${$t('customer.phone-no')}`, `email: ${$t('customer.email')}`, `status: ${$t('property.status')}`, `address: ${$t('customer.address')}`]" 
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'customer-edit'}"
          v-bind:view="{link: 'customer-view'}"
          v-bind:more="{
            sub: [{
              name: 'customer.follow-up.text', icon:'bx bx-file', link: 'customer-followup', column: 'id'
            }]
          }"
          v-bind:filter="{
            search: ['customers.code', 'customers.name', 'customers.name_en', 'customers.phone_no_1', 'customers.phone_no_2'],
            dropdown: [{
              title: 'customer.type',
              field: 'customers.type_id',
              data: this.typeData.data,
              width: 2
            }, {
              title: 'property.status',
              field: 'customers.customer_status_id',
              data: this.statusData.data,
              width: 2
            }]
          }"
          
    />      
  </Layout>
</template>